export const validationResponseStatus = {
  IsAvailable: 200,
  IsUnavailable: 400,
  Error: 1000
}
